var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 42,
    height: 42,
    rx: 10,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.464 22.4L27.086 18.345H23.196V15.717C23.1687 15.4142 23.21 15.1091 23.3167 14.8243C23.4233 14.5395 23.5927 14.2824 23.8123 14.072C24.0318 13.8616 24.2959 13.7032 24.5849 13.6087C24.874 13.5142 25.1806 13.486 25.482 13.526H27.251V10.074C26.2124 9.90626 25.1629 9.81469 24.111 9.80005C20.911 9.80005 18.811 11.742 18.811 15.258V18.348H15.25V22.4H18.812V32.2H23.196V22.4H26.464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.841edbd81a6e3de039354a419b0ceaf3.svg";
export { ForwardRef as ReactComponent };